import React, {useState} from "react";
import styled from "styled-components";
import Modal from "src/core/common/components/modules/modal/Modal";
import {
  ModalBackButton,
  ModalContainer,
  ModalHeader,
  ModalText,
} from "src/core/common/components/modules/modal/modalComponents";
import useRouter from "src/core/common/hooks/useRouter";
import {PrimaryLoadingButton} from "src/core/common/components/elements/button/PrimaryButton";
import {FormContainer, FormText} from "src/core/common/components/collections/form/forms";
import IdentityVerificationForm from "src/integrations/identityVerification/components/IdentityVerificationForm";
import {IdVerificationContext} from "src/integrations/identityVerification/components/IdentityVerificationContext";
import routes from "src/core/common/routes";

export default function IdentityVerificationModal({isOpen, closeModal}) {
  const router = useRouter();

  const [isIdVerifierOpen, setIsIdVerifierOpen] = useState(false);

  function openIdentityVerifier() {
    setIsIdVerifierOpen(true);
  }

  function onFinishVerification() {
    router.push({
      pathname: routes.personalInfo,
      query: {close: true},
      keepQuery: false,
    });
  }

  if (isIdVerifierOpen) {
    return (
      <IdVerificationContext.Consumer>
        {(value) => {
          if (value.idVerification) {
            return (
              <IdentityVerificationForm
                identityVerification={value.idVerification}
                onFinish={onFinishVerification}
              />
            );
          }

          return null;
        }}
      </IdVerificationContext.Consumer>
    );
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={closeModal}>
      <ModalBackButton onClick={() => router.safeBack()} />
      <ModalContainer>
        <CustomModalHeader>We need to verify your ID</CustomModalHeader>
        <CenterModalText>
          To complete the upload of your ID, we must be 100% sure that You are You. As a
          cannabis business, we have to ensure some safety measures to safeguard you and
          our employees. You just need to go through some steps which will help us to
          build a secure system together.
        </CenterModalText>
        <FormContainer>
          <PrimaryLoadingButton onClick={openIdentityVerifier}>
            Verify
          </PrimaryLoadingButton>
          <Footer alignment={"center"}>
            <span>Verified by Berbix.</span>
          </Footer>
        </FormContainer>
      </ModalContainer>
    </Modal>
  );
}

const CenterModalText = styled(ModalText)`
  text-align: center;
  margin-bottom: 50px;
`;

const Footer = styled(FormText)`
  text-align: center;
  margin-top: ${({theme}) => theme.v2.spacing(6)};
`;

const CustomModalHeader = styled(ModalHeader)`
  margin-top: 48px;
`;
